<template>
  <q-page class="flex flex-center">
    <form @submit.prevent="submitLogin" class>
      <q-card class="md-card q-mt-lg relative-position" color="grey-1">
        <q-card-title class="bg-secondary text-white">Forgot Password</q-card-title>
        <q-card-separator/>
        <q-card-main>
          <q-field
            label="Email Address"
            orientation="vertical"
            icon="email"
            helper="please type in your email address to reset your password"
            class="q-mt-lg q-mb-lg text-black"
          >
            <q-input v-model="email" autofocus type="email"/>
          </q-field>
          <div v-if="error">
            <q-alert
              color="negative"
              icon="error"
              enter="fadeIn"
              leave="fadeOut"
              appear
              dismissible
            >
              <b>Issue requesting password reset:</b>
              {{ error }}
            </q-alert>
          </div>
          <div v-if="message" class="q-ma-lg">
            <q-alert
              color="blue-4"
              icon="info"
              enter="fadeIn"
              leave="fadeOut"
              appear
              dismissible
            >{{ message }}</q-alert>
          </div>
        </q-card-main>
        <q-card-actions v-if="!requiresEmail">
          <q-btn
            v-model="loading"
            loader
            large
            color="primary"
            class="full-width no-shadow"
            type="submit"
            :disabled="loading"
            label="Send Email"
          >
            <span slot="loading">
              <q-spinner class="on-left"/>Requesting Password Email ...
            </span>
          </q-btn>
        </q-card-actions>
        <q-inner-loading :visible="loading"/>
      </q-card>
    </form>
  </q-page>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ForgotPasswordPage',
  data () {
    return {
      loading: false,
      error: null,
      message: null
    }
  },
  computed: {
    ...mapState('auth', ['login']),
    requiresEmail () {
      return this.login.requiresEmail
    },
    email: {
      get () {
        return this.login.email
      },
      set (value) {
        this.$store.commit('auth/SET_LOGIN_KEY', {
          key: 'email',
          value
        })
      }
    }
  },
  methods: {
    ...mapActions('auth', ['loginUser', 'sendForgotEmail', 'doVerifyAccount']),
    async submitLogin () {
      this.error = ''
      this.message = ''
      if (!this.formDisabled && !this.loading) {
        this.loading = true
        try {
          const valid = await this.sendForgotEmail({ client: this.$axios, email: this.email })
          if (valid) {
            this.message = `An email has been sent with reset instructions`
          } else {
            this.error = 'Sorry, we could not find your email address in our system'
          }
          this.loading = false
        } catch (error) {
          // console.log(error)
          this.loading = false
          this.error = 'Could not send email. Please try again.'
        }
      }
    }
  },
  mounted () {
    if (this.$route.query.logout) {
      if (this.$route.query.logout === 'success') {
        this.$set(this, 'message', 'You have been logged out successfully')
      }
      if (this.$route.query.logout === 'inactivity') {
        this.$set(this, 'message', 'You have been logged out due to inactivity')
      }
    }
  }
}
</script>
